export default __webpack_public_path__ + "static/media/img_shop-type07.6c27ffb1.png";